import { useMPEFetch, useMutateMPEFetch } from '@retail/app/hooks';
import { useAuthContext } from '@retail/auth/data-access';
import { PaginationResultDTO, QueryOptions } from '@shared/fetch-utils';
import { EnvironmentFilter, SupplierItemInsightDTO } from '@retail/products/types';
import { buildUrl } from '@shared/utils';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { mpeApi } from '@retail/mgpris/config';

interface Props {
  assortmentId?: number;
  assortmentTagIds: string[];
  productGroup?: string;
  mgParticipantAccountId?: number;
  articleId?: number;
  text?: string;
  climateFilters: boolean;
  environmentFilters: EnvironmentFilter;
  hasFilterFields: boolean;
  page: number;
  size: number;
}

export function useFetchSupplierItemsInsightReport(
  {
    assortmentId,
    assortmentTagIds,
    productGroup,
    mgParticipantAccountId,
    articleId,
    text,
    environmentFilters,
    climateFilters,
    hasFilterFields,
    page,
    size,
  }: Props,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PaginationResultDTO<SupplierItemInsightDTO[]>>({
    method: 'POST',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.supplierItemsInsightReport.getFullLinkPath(),
      searchParams: {
        assortmentId,
        assortmentTagIds,
        mgParticipantAccountId,
        productGroup,
        articleId,
        text,
        hasFilterFields,
        page,
        size,
      },
    }),
    body: { environmentFilters, climateFilters: climateFilters ? { a1a3: true } : undefined },
    token,
    queryKey: [
      'supplier-item-insight',
      assortmentId,
      assortmentTagIds,
      mgParticipantAccountId,
      productGroup,
      articleId,
      text,
      environmentFilters,
      climateFilters,
      hasFilterFields,
      page,
      size,
    ],
    ...queryOptions,
  });
}

interface InsightReportSearchQuery {
  productGroup?: string;
  mgParticipantAccountId?: number;
  articleId?: number;
  text?: string;
  hasFilterFields: boolean;
  page: number;
  size: number;
}

interface InsightReportBody {
  climateFilters?: { A1A3: boolean };
  environmentFilters?: EnvironmentFilter;
}

export function useMutateFetchSupplierItemsInsightReport() {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<
    PaginationResultDTO<SupplierItemInsightDTO[]>,
    InsightReportBody,
    InsightReportSearchQuery
  >({
    method: 'POST',
    token,
    url: (searchParams) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.supplierItemsInsightReport.getFullLinkPath(),
        searchParams: {
          ...searchParams,
        },
      }),
  });
}
